'use strict';

module.exports = require('react/lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 34
// module chunks = 0